import  { useEffect, useState, createContext, useContext } from "react";
import apisService from "api/services/apiService";

const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [appSettings, setAppSettings] = useState({});

  const getAppSettings = () => {
    apisService.user.getSettings().then(({ data }) => setAppSettings(data));
  };

  useEffect(() => {
    getAppSettings();
  }, []);

  return (
    <AppContext.Provider
      value={{ appSettings, setAppSettings, getAppSettings }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
